import { AutocompleteListItem } from "models/propTypes/listPropTypes";
import { useEffect, useState } from "react";
import { useSalaryService } from "serviceHooks";
import { IconDefinitionConstants } from "utils/constants";

function useSalaryEmployeeSearch() {
  const { searchSalaryEmployees } = useSalaryService();
  const [employeeSuggestions, setEmployeeSuggestions] = useState<AutocompleteListItem[]>([]);

  const searchEmployees = (searchString: string) => {
    return searchSalaryEmployees(searchString).then((res) =>
      res.map(
        (employee): AutocompleteListItem => ({
          id: employee.id,
          value: employee.name ?? "",
          icon: IconDefinitionConstants.WUser,
        })
      )
    );
  };

  useEffect(() => {
    searchEmployees("").then((res) => {
      setEmployeeSuggestions(res);
    });
  }, []);

  return { employeeSuggestions, searchEmployees };
}

export default useSalaryEmployeeSearch;
